import * as Yup from 'yup';
import { validatePhone } from 'validations-br';

const requiredFieldMessage = 'Campo obrigatório';
const schema = Yup.object().shape({
  email: Yup.string()
    .email('Precisa ser um email válido')
    .required(requiredFieldMessage),
  state: Yup.string().required(requiredFieldMessage),
  address: Yup.string().required(requiredFieldMessage),
  number: Yup.string().required(requiredFieldMessage),
  neighborhood: Yup.string().required(requiredFieldMessage),
  city: Yup.string().required(requiredFieldMessage),
  cep: Yup.string().required(requiredFieldMessage),
  phone: Yup.string()
    .required(requiredFieldMessage)
    .test('is-phone', 'Precisa ser um número válido', (value) => validatePhone(String(value))),
});

export default schema;
